import { transparentize } from 'polished';
import styled, { css } from 'styled-components';

export type AlertLevel = 'warning' | 'danger';
export const Wrapper = styled.div<{ $level: AlertLevel }>(
  ({ theme, $level }) => css`
    align-self: flex-start;
    box-sizing: border-box;
    width: fit-content;
    max-width: min(100%, ${theme.sz.s});
    padding: ${theme.sz.s2} ${theme.sz.s4};
    font-size: ${theme.DEPRECATED_ty.larger};
    font-weight: ${theme.DEPRECATED_ty.semiBold};
    border-radius: ${theme.bo.small};

    ${
      $level === 'warning' &&
      css`
        color: ${theme.co.warning0};
        background-color: ${transparentize(0.5, theme.co.warning80)};
      `
    };
    ${
      $level === 'danger' &&
      css`
        color: ${theme.co.error10};
        background-color: ${theme.co.error90};
      `
    };
  `,
);

export const Title = styled.h3(
  ({ theme }) => css`
    margin: 0;
    margin-bottom: ${theme.sz.s1};
    font-weight: ${theme.DEPRECATED_ty.bold};
    font-size: ${theme.DEPRECATED_ty.smaller};
    text-transform: uppercase;
    color: inherit;
  `,
);
